import React from 'react';

const Heading = ({ heading }) => (
    <h1 className="my-5 text-4xl font-bold dark:text-white">
        {heading}
    </h1>
)

export default Heading